import React from "react";


import {
    PageContainerComponent
} from "@Components/Sections";

import {
    SupportSectionComponent
} from "@Parts/@Support";

import {
    HeadSectionComponent
} from "@Parts/Sections";


import {
    LegalElementsListComponent
} from "@Pages/@LegalPages/@Parts/LegalsElementsList";

import {
    LegalElementsListElementType
} from "@Pages/@LegalPages/@Parts/LegalsElementsList/LegalElement";


import headSectionImage from "./@Images/headSectionImage.svg";


import "./index.scss";


const LegalElementsList:LegalElementsListElementType[] = [
    {
        elementOrderNr: 1,
        elementTitle: 'Acceptance & Definitions',
        elementContent: `
            <p>By accessing the Qyvo website or authorising our service (“Service”) you agree to these Terms (“Agreement”). “Refund” means any monetary amount returned by a third‑party (airline, merchant, government) that was facilitated by Qyvo. “Success Fee” means the commission Qyvo automatically charges once a Refund is confirmed.</p>
        `
    },
    {
        elementOrderNr: 2,
        elementTitle: 'Eligibility',
        elementContent: `
            <p>You must be at least 18 years old and capable of entering into contracts. If you connect an inbox or account, you represent that you are the rightful owner or have lawful authority.</p>
        `
    },
    {
        elementOrderNr: 3,
        elementTitle: 'Service Overview',
        elementContent: `
            <p>Qyvo scans authorized data sources (e.g., email, receipts) to identify unused tickets or other refundable charges, files claims on your behalf, tracks outcomes, and collects a Success Fee once funds are credited to your original payment method or to a refund wallet.</p>
        `
    },
    {
        elementOrderNr: 4,
        elementTitle: '',
        elementContent: `
            <p>Standard plan: 25% of net Refund amount ("Success Fee"). Subscription plan (optional): USD 2.99 / PLN 23 per month + 5 % Success Fee. Fees are billed automatically via the payment method you provide (Stripe MIT). All fees are non‑refundable once the Service has been performed and a claim has been filed, except where mandatory consumer law grants a cooling‑off right (see Section 6).</p>
        `
    },
    {
        elementOrderNr: 5,
        elementTitle: 'Refund Policy',
        elementContent: `
            <p>Because Qyvo’s work is performed immediately upon filing a claim and cannot be undone, you acknowledge that no withdrawal or refund of the Success Fee is available once a claim is submitted, to the maximum extent permitted by applicable consumer protection laws. If you are an EU consumer, you expressly request that we begin performing the Service during the 14‑day cooling‑off period and acknowledge you lose the right of withdrawal once the Service is fully performed.</p>
        `
    },
    {
        elementOrderNr: 6,
        elementTitle: 'EU Consumer Right of Withdrawal',
        elementContent: `
            <p>Because Qyvo’s work is performed immediately upon filing a claim and cannot be undone, you acknowledge that no withdrawal or refund of the Success Fee is available once a claim is submitted, to the maximum extent permitted by applicable consumer protection laws. If you are an EU consumer, you expressly request that we begin performing the Service during the 14‑day cooling‑off period and acknowledge you lose the right of withdrawal once the Service is fully performed.</p>
        `
    },
    {
        elementOrderNr: 7,
        elementTitle: 'Your Obligations',
        elementContent: `
            <ul>
                <li>Provide accurate information and maintain valid payment details.</li>
                <li>Do not misrepresent or submit fraudulent claims.</li>
                <li>Revoke access if you sell your email account or device.</li>
            </ul>
        `
    },
    {
        elementOrderNr: 8,
        elementTitle: 'Acceptable Use',
        elementContent: `
            <p>You agree not to reverse‑engineer, abuse, or interfere with the Service, and not to use Qyvo for any illegal purpose.</p>
        `
    },
    {
        elementOrderNr: 9,
        elementTitle: 'Intellectual Property',
        elementContent: `
            <p>All software, trademarks, and content are owned by Qyvo or its licensors. You receive a non‑exclusive, revocable license to use the Service.</p>
        `
    },
    {
        elementOrderNr: 10,
        elementTitle: 'Third‑Party Services',
        elementContent: `
            <p>The Service interacts with airlines, payment networks, and APIs outside Qyvo’s control. We are not responsible for their performance or data accuracy.</p>
        `
    },

    {
        elementOrderNr: 11,
        elementTitle: 'Disclaimer',
        elementContent: `
            <p>The Service is provided “as‑is” without warranties of any kind. We do not guarantee any specific refund amount.</p>
        `
    },
    {
        elementOrderNr: 12,
        elementTitle: 'Limitation of Liability',
        elementContent: `
            <p>To the fullest extent permitted by law, Qyvo’s aggregate liability shall not exceed the greater of USD 100 / PLN 400 or the total Success Fees paid by you in the preceding 12 months.</p>
        `
    },
    {
        elementOrderNr: 13,
        elementTitle: 'Indemnification',
        elementContent: `
            <p>You agree to indemnify Qyvo for claims arising from your breach of this Agreement or unlawful use of the Service.</p>
        `
    },
    {
        elementOrderNr: 14,
        elementTitle: 'Suspension & Termination',
        elementContent: `
            <p>You may disconnect at any time via account settings. We may suspend or terminate access for abuse or non‑payment. Sections 4–5, 9, 11–13 survive termination.</p>
        `
    },
    {
        elementOrderNr: 15,
        elementTitle: 'Governing Law & Venue',
        elementContent: `
            <p>This Agreement is governed by Polish law. Courts of Gdańsk have exclusive jurisdiction, without prejudice to mandatory consumer venue rights.</p>
        `
    },
    {
        elementOrderNr: 16,
        elementTitle: 'Dispute Resolution & EU ODR',
        elementContent: `
            <p>We prefer to resolve disputes amicably — email legal@useqyvo.com first. EU consumers may also submit disputes via the Online Dispute Resolution platform: https://ec.europa.eu/consumers/odr.</p>
        `
    },
    {
        elementOrderNr: 17,
        elementTitle: 'Changes to the Terms',
        elementContent: `
            <p>We may update these Terms with 14‑days’ notice. Continued use after changes means acceptance.</p>
        `
    },
    {
        elementOrderNr: 18,
        elementTitle: 'Contact',
        elementContent: `
            <p>General: hello@useqyvo.com | Legal: legal@useqyvo.com | Privacy: privacy@useqyvo.com</p>
        `
    },
    {
        elementTitle: 'Cookie Policy (Banner Reference)',
        elementContent: `
            <p>We use CookieConsent v3.1 script hosted on EU servers. The banner loads only essential cookies by default and requires affirmative action for analytics or marketing cookies. A full Cookie Policy page is available at https://useuseqyvo.com/cookies.</p>
        `
    },
    {
        elementTitle: 'Data‑Processing Addendum (Outline)',
        elementContent: `
            <p>For B2B customers, Qyvo offers a one‑page DPA meeting GDPR Art 28 requirements, including:</p>
            <ul>
                <li>Subject matter & duration (refund processing, term of SaaS contract)</li>
                <li>Nature & purpose (identify & file claims)</li>
                <li>Data categories & subjects</li>
                <li>Sub‑processor list & SCCs</li>
                <li>Technical & organisational measures</li>
                <li>Audit rights & breach notification within 72h</li>
                <li>Deletion or return of data upon termination</li>
            </ul>
            <p>Request the signed DPA at dpa@useqyvo.com.</p>       
        `
    },
]


export const TermsOfServicePage:React.FC = () => {

    return (
        <PageContainerComponent pageType={'terms-of-service-page'}>

            <HeadSectionComponent
                pageName={'terms-of-service'}
                sectionHeaderText={'Terms of Service'}
                sectionSubText={'Last updated: 2025.09.01'}
                sectionImage={headSectionImage}
            />

            <LegalElementsListComponent
                legalPageType={'terms-of-service'}
                legalElementsList={LegalElementsList}
            />

            <SupportSectionComponent />

        </PageContainerComponent>
    );

};


export default TermsOfServicePage;
